import client from "lib/apolloClient/client";
import {
  updateAIFeedbackCommentMutation,
  upsertFeedbackStatusMutation,
} from "./AIFeedbackStripMutations";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

export const upsertAIFeedbackStatus = ({ feedbackStatusInput }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: upsertFeedbackStatusMutation,
        variables: {
          input: feedbackStatusInput,
        },
      });
      return {
        isSuccess: true,
      };
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {
        isSuccess: false,
      };
    }
  };
};

export const updateAIFeedbackComment = ({ feedbackCommentInput }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateAIFeedbackCommentMutation,
        variables: {
          input: feedbackCommentInput,
        },
      });
      return {
        isSuccess: true,
      };
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {
        isSuccess: false,
      };
    }
  };
};
